import {
  AddRatingInternalInput,
  Message,
  QueryCoralcommentsArgs,
  RatingAverageResponse,
  RatingResponse,
} from '@repo/api/open-calls/graphql';
import request from 'graphql-request';
import { ConfigService } from '../../services';
import { QueryStateManagement } from '../../state';
import * as constants from '../constants';
import {
  mutationCreateRating,
  queryCandidateRatingAverage,
  queryGetRatings,
} from './queries.graphql';

export class RatingsService {
  static async createRating(variables: {
    input: AddRatingInternalInput;
  }): Promise<string | undefined> {
    try {
      const response = await QueryStateManagement.client.fetchQuery({
        queryKey: ['create-rating', variables.input.submissionID],
        queryFn: () =>
          request<Message>(
            `${ConfigService.BACKEND_GRAPHQL_ENDPOINT}${window.location.search}`,
            mutationCreateRating,
            variables,
            {
              Authorization: `Bearer ${sessionStorage.getItem(constants.TOKEN_STORAGE_KEY)}`,
            },
          ),
        gcTime: constants.QUERY_CACHE_TIME,
      });
      return response.message as string | undefined;
    } catch (error) {
      console.error('Error creating rating:', error);
      throw error;
    }
  }

  static async fetchRatings(
    variables: QueryCoralcommentsArgs,
  ): Promise<RatingResponse[]> {
    try {
      const response = await QueryStateManagement.client.fetchQuery({
        queryKey: ['get-ratings', variables.submissionID],
        queryFn: () =>
          request<{ coralratings: RatingResponse[] }>(
            `${ConfigService.BACKEND_GRAPHQL_ENDPOINT}${window.location.search}`,
            queryGetRatings,
            variables,
            {
              Authorization: `Bearer ${sessionStorage.getItem(constants.TOKEN_STORAGE_KEY)}`,
            },
          ),
        gcTime: constants.QUERY_CACHE_TIME,
      });

      return response.coralratings;
    } catch (error) {
      console.error('Error getting ratings:', error);
      throw error;
    }
  }

  static async fetchCandidateRatingAverage(
    submissionID: string,
  ): Promise<RatingAverageResponse> {
    try {
      const response = await QueryStateManagement.client.fetchQuery({
        queryKey: ['get-candidate-rating-average', submissionID],
        queryFn: () =>
          request<{ storyRating: RatingAverageResponse }>(
            `${ConfigService.BACKEND_GRAPHQL_ENDPOINT}${window.location.search}`,
            queryCandidateRatingAverage,
            { submissionID },
            {
              Authorization: `Bearer ${sessionStorage.getItem(constants.TOKEN_STORAGE_KEY)}`,
            },
          ),
        gcTime: constants.QUERY_CACHE_TIME,
      });
      return response.storyRating;
    } catch (error) {
      console.error('Error getting candidate rating average:', error);
      throw error;
    }
  }
}
